import React from "react";

const MarketingSVG = ({ activeSvgColor }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.61328 6.61097V2.9202C6.61328 2.12219 7.21179 1.42394 8.00979 1.22444C10.0048 0.925187 11.9998 0.925187 13.9948 1.22444C14.7928 1.32419 15.3913 2.02244 15.3913 2.9202V8.80549C15.3913 10.0025 14.3938 11 13.1968 11H8.8078C7.61079 11 6.61328 11.9975 6.61328 13.1945V19.0798C6.61328 19.8778 7.21179 20.5761 8.00979 20.7756C10.0048 21.0748 11.9998 21.0748 13.9948 20.7756C14.7928 20.6758 15.3913 19.9776 15.3913 19.0798V15.389"
        stroke={activeSvgColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.389 6.61035H19.0798C19.8778 6.61035 20.5761 7.20886 20.7756 8.00686C21.0748 10.0019 21.0748 11.9969 20.7756 13.9919C20.6758 14.7899 19.9776 15.3884 19.0798 15.3884H11M11 6.61035H2.9202C2.12219 6.61035 1.42394 7.20886 1.22444 8.00686C0.925187 10.0019 0.925187 11.9969 1.22444 13.9919C1.32419 14.7899 2.02244 15.3884 2.9202 15.3884H6.61097"
        stroke={activeSvgColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MarketingSVG;
